import { applyMiddleware, combineReducers, createStore } from 'redux'
import { sidebarShowReducer, sidebarUnfoldableReducer } from './redux/sidebar'
import { composeWithDevTools } from 'redux-devtools-extension'
import { thunk } from 'redux-thunk'
import loginReducer from './redux/login'
import { appReducer, appUserReducer } from './redux/appusers'
import adminReducer from './redux/adminusers'
import signupReducer from './redux/signup'
import reportReducer from './redux/reportdata'
import paymentHistoryReducer from './redux/paymenthistory'
import {
  addmasterReducer,
  deletemasterReducer,
  getmasterReducer,
  updatemasterReducer,
} from './redux/masterdata'
import {
  deleteNotificationReducer,
  getNotificationReducer,
  sendNotificationReducer,
} from './redux/notification'
import { bankDetailsReducer } from './redux/bankdetails'
import { registrationReducer, signupAppReducer, verifyOtpReducer } from './redux/registration'
import { adminProfileReducer } from './redux/adminprofile'
import { dashboardReducer } from './redux/dashboard'
import { navigationReducer } from './redux/navigation'
import { countryReducer } from './redux/country'
import { statesReducer } from './redux/states'
import { citiesReducer } from './redux/cities'
import reportUsersReducer from './redux/reportusers'
import { bannerReducer } from './redux/banner'
import { couponReducer } from './redux/coupons'
import { blogReducer } from './redux/blogs'
import { categoryReducer } from './redux/categories'
import { subcategoryReducer } from './redux/subcategories'
import { productReducer } from './redux/products'
import { menusReducer } from './redux/menus'
import { shoppingCartReducer } from './redux/shoppingcart'
import { ordersReducer } from './redux/orders'
import { salesReportsReducer } from './redux/salesreports'
import { customerReportsReducer } from './redux/customerreports'
import { taxInvoiceReducer } from './redux/taxinvoice'
import { deliveryBoysReducer } from './redux/deliveryboys'
import { sendWhatsAppReducer } from './redux/sendwhatsapp'
import { makeCallReducer } from './redux/calling'

const rootReducer = combineReducers({
  sidebarShow: sidebarShowReducer,
  sidebarUnfoldable: sidebarUnfoldableReducer,
  country: countryReducer,
  states: statesReducer,
  cities: citiesReducer,
  login: loginReducer,
  signup: signupReducer,
  appusers: appReducer,
  appuser: appUserReducer,
  adminusers: adminReducer,
  deliveryboys: deliveryBoysReducer,
  reportdata: reportReducer,
  reportusers: reportUsersReducer,
  bankdetails: bankDetailsReducer,
  getmasterdata: getmasterReducer,
  addmasterdata: addmasterReducer,
  updatemasterdata: updatemasterReducer,
  deletemasterdata: deletemasterReducer,
  paymenthistory: paymentHistoryReducer,
  getnotification: getNotificationReducer,
  sendnotification: sendNotificationReducer,
  deletenotification: deleteNotificationReducer,
  signupapp: signupAppReducer,
  verifyotp: verifyOtpReducer,
  registration: registrationReducer,
  adminprofile: adminProfileReducer,
  admindashboard: dashboardReducer,
  adminnavigation: navigationReducer,
  banners: bannerReducer,
  coupons: couponReducer,
  blogs: blogReducer,
  categories: categoryReducer,
  subcategories: subcategoryReducer,
  products: productReducer,
  menus: menusReducer,
  shoppingcart: shoppingCartReducer,
  orders: ordersReducer,
  salesreports: salesReportsReducer,
  customerreports: customerReportsReducer,
  customerinvoice: taxInvoiceReducer,
  sendwhatsapp: sendWhatsAppReducer,
  calling: makeCallReducer,
})

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)))
export default store
